<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions" class="button-icon full-icon">
    <span class="relative">
        @if (showAvatar && user.avatar) {
            <img class="h-7 w-7 rounded-lg" [src]="user.avatar" />
        }
        @if (!showAvatar || !user.avatar) {
            <i class="hgi-stroke hgi-user"></i>
        }
        <span
            class="absolute bottom-0 right-0 h-2 w-2 rounded-lg"
            [ngClass]="{
                'mb-px mr-px': !showAvatar || !user.avatar,
                'bg-green-500': user.status === 'online',
                'bg-amber-500': user.status === 'away',
                'bg-red-500': user.status === 'busy',
                'bg-gray-400': user.status === 'not-visible',
            }"
        ></span>
    </span>
</button>

<mat-menu
[xPosition]="'before'"
#userActions="matMenu"
class="user-session-menu-container">
    <div class="user-session-menu-body">
        <p class="label-like">Iniciaste sesión como</p>
        <p class="user-mail truncate">{{ user.email }}</p>
        <hr class="" />
    </div>
    <div class="user-session-menu-footer">
        <div class="list-btn-like"
        (click)="signOut()">
            <i class="hgi-stroke hgi-logout-02"></i>
                <span>Salir</span>
        </div>
    </div>
</mat-menu>

<mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>
